import alcatel from './assets/images/servizi/alcatel.png';
import alpine from './assets/images/servizi/alpine.gif';
// import autovox from './assets/images/servizi/autovox_b.png';
import fuba from './assets/images/servizi/fuba.png';
import h3gwind from './assets/images/servizi/h3gwind.jpg';
import haier from './assets/images/servizi/haier.jpg';
import hannspree from './assets/images/servizi/hannspree.png';
import hisense from './assets/images/servizi/hisense.png';
// import hkc from './assets/images/servizi/hkc.png';
import howell from './assets/images/servizi/howell.png';
// import huawei from './assets/images/servizi/huawei.png';
import idsat from './assets/images/servizi/idsat.jpg';
import kitech from './assets/images/servizi/kitech.jpg';
import lenoir from './assets/images/servizi/lenoir.png';
import lg from './assets/images/servizi/lg.png';
// import lenovo from './assets/images/servizi/lenovo.png';
import loewe from './assets/images/servizi/loewe.svg';
import mediacom from './assets/images/servizi/mediacom.gif';
import nodis from './assets/images/servizi/nodis.jpg';
import oppo from './assets/images/servizi/oppo.png';
import philips from './assets/images/servizi/philips.png';
import pioneerDj from './assets/images/servizi/pioneer_dj.png';
import pioneer from './assets/images/servizi/pioneer.gif';
import sennheiser from './assets/images/servizi/sennheiser.png';
import telesystem from './assets/images/servizi/telesystem.png';
import trevi from './assets/images/servizi/trevi.jpg';
// import ultravox from './assets/images/servizi/ultravox.jpg';
// import vexa from './assets/images/servizi/vexa.jpg';
// import vortis from './assets/images/servizi/vortis.png';
import wiko from './assets/images/servizi/wiko.jpg';
import xiaomi from './assets/images/servizi/xiaomi.png';
// import yota from './assets/images/servizi/yota.jpg';
import zephir from './assets/images/servizi/zephir.png';
import zte from './assets/images/servizi/zte.png';

const brands = [
    {
        logo: alcatel,
        url: 'https://us.alcatelmobile.com/',
        name: 'Alcatel'
    },
    {
        logo: alpine,
        url: 'https://italy.alpine-europe.com/',
        name: 'Alpine'
    },
    // {
    //     logo: autovox,
    //     url: 'http://www.autovox.it/',
    //     name: 'Autovox'
    // },
    {
        logo: fuba,
        url: 'http://www.fuba.com/web/it_it/electronic/home.html',
        name: 'Fuba'
    },
    {
        logo: h3gwind,
        url: 'http://www.windtre.it/',
        name: 'H3gWind'
    },
    {
        logo: haier,
        url: 'http://www.haiercondizionatori.it/',
        name: 'Haier'
    },
    {
        logo: hannspree,
        url: 'http://www.hannspree.eu/it',
        name: 'Hannspree'
    },
    {
        logo: hisense,
        url: 'https://www.hisenseitalia.it/',
        name: 'Hisense'
    },
    // {
    //     logo: hkc,
    //     url: 'http://hkc-eu.com/',
    //     name: 'HKC'
    // },
    {
        logo: howell,
        url: 'http://www.howell.it/',
        name: 'Howell'
    },
    // {
    //     logo: huawei,
    //     url: 'https://consumer.huawei.com/it/',
    //     name: 'Huawei'
    // },
    {
        logo: idsat,
        url: 'https://www.eurosat-online.it/',
        name: 'IDSat'
    },
    {
        logo: kitech,
        url: '',
        name: 'Kitech'
    },
    {
        logo: lenoir,
        url: '',
        name: 'Lenoir'
    },
    {
        logo: lg,
        url: 'https://www.lg.com/it',
        name: 'Lg'
    },
    // {
    //     logo: lenovo,
    //     url: 'https://www3.lenovo.com/it/it/',
    //     name: 'Lenovo'
    // },
    {
        logo: loewe,
        url: 'https://www.loewe.tv/it',
        name: 'Loewe'
    },
    {
        logo: mediacom,
        url: '',
        name: 'Mediacom'
    },
    {
        logo: nodis,
        url: 'http://www.nodis-italia.it/',
        name: 'Nodis'
    },
    {
        logo: oppo,
        url: 'https://www.oppo.com/it/',
        name: 'Oppo'
    },
    {
        logo: philips,
        url: 'https://www.philips.it/',
        name: 'Philips'
    },
    {
        logo: pioneerDj,
        url: 'https://www.pioneerdj.com/it-it/',
        name: 'Pioneer Dj'
    },
    {
        logo: pioneer,
        url: 'http://www.pioneer.eu/',
        name: 'Pioneer'
    },
    {
        logo: sennheiser,
        url: 'https://en-us.sennheiser.com/',
        name: 'Sennheiser'
    },
    {
        logo: telesystem,
        url: 'http://www.telesystem-world.com/0/1/it/home/',
        name: 'Telesystem'
    },
    {
        logo: trevi,
        url: 'https://www.trevi.it/cms/home.html',
        name: 'Trevi'
    },
    // {
    //     logo: ultravox,
    //     url: '',
    //     name: 'Ultravox'
    // },
    // {
    //     logo: vexa,
    //     url: '',
    //     name: 'Vexa'
    // },
    // {
    //     logo: vortis,
    //     url: 'http://www.westim.it/',
    //     name: 'Vortis'
    // },
    {
        logo: wiko,
        url: 'https://it.wikomobile.com/',
        name: 'Wiko'
    },
    {
        logo: xiaomi,
        url: 'https://www.mi.com/it/',
        name: 'Xiaomi'
    },
    // {
    //     logo: yota,
    //     url: 'https://www.yota.ru/',
    //     name: 'Yota'
    // },
    {
        logo: zephir,
        url: 'http://www.zephir.it/',
        name: 'Zephir'
    },
    {
        logo: zte,
        url: 'https://ztedevices.it/',
        name: 'Zte'
    }
];

export default brands;